import React from "react";
import { BOND_PRINCIPAL_KIND } from "../../shared/hooks/useBondPrincipalForm";
import BondPrincipalScreen from "../../shared/components/BondPrincipalScreen";
import { BOND_PRINCIPAL_SHELL_PROBATE } from "../../shared/bondWizardStepPropTypes";

const PersonalRepresentatives = ({
  data,
  updateData,
  globalData,
  errors,
  isGuest,
}) => (
  <BondPrincipalScreen
    kind={BOND_PRINCIPAL_KIND.probate}
    data={data}
    updateData={updateData}
    globalData={globalData}
    errors={errors}
    isGuest={isGuest}
    includeAttorneyLawFirmIdInPgFetchDeps={true}
  />
);

PersonalRepresentatives.propTypes = BOND_PRINCIPAL_SHELL_PROBATE;

export default PersonalRepresentatives;
